















































import Vue from 'vue'
import Api from '@/api'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import { TemplateModule } from '@/store/modules/template.module'
import { ResidentModule } from '@/store/modules/resident.module'
import { StatementModule } from '@/store/modules/statement.module'
import PdfViewer from '@/components/PdfViewer.vue'
import Icon from '@/components/Icon.vue'
import CollectionMailContacts from './components/CollectionMailContacts.vue'
import GoBack from '@/components/GoBack.vue'
import Card from '@/components/Card.vue'
import { IResidentContact } from '@zunta/configurations'

@Component({
  components: {
    Card,
    GoBack,
    PdfViewer,
    Icon,
    CollectionMailContacts
  }
})
export default class CollectionMailReview extends Vue {
  templateModuleInstance: TemplateModule = getModule(TemplateModule, this.$store)
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  statementModuleInstance: StatementModule = getModule(StatementModule, this.$store)
  selected: any = {
    addresses: [],
    emails: []
  };
  isLoading: boolean = false
  isSending: boolean = false

  get itemId () {
    return this.$route.params.id
  }

  get type () {
    return this.$route.params.type
  }

  get src () {
    if (this.type === 'template') {
      return `${this.itemId}/${this.residentId}${this.firstSelectedRecipientUrl}`
    }
    return this.selectedStatement ? this.selectedStatement.pdf : null
  }

  get isMultipleRecipients () {
    return [
      ...new Set(this.selected.addresses.concat(this.selected.addresses.emails)
        .filter((rec: any) => !!rec)
        .map((rec: any) => rec.id))
    ].length > 1
  }

  get firstSelectedRecipientName () {
    if (!this.firstSelectedRecipient) {
      return ''
    }

    const res = this.residentContactList.find((recipient: IResidentContact) => this.firstSelectedRecipient === recipient.id)
    return `${res && res.firstName ? res.firstName : ''} ${res && res.lastName ? res.lastName : ''}`
  }

  get firstSelectedRecipient () {
    if (this.selected.addresses.concat(this.selected.addresses.emails)[0]) {
      return this.selected.addresses.concat(this.selected.addresses.emails)[0].id
    }
    return this.selectedStatement && this.selectedStatement.length ? this.selectedStatement[0].id : ''
  }

  get firstSelectedRecipientUrl () {
    if (this.selected.addresses.concat(this.selected.addresses.emails)[0]) {
      return '/' + this.selected.addresses.concat(this.selected.addresses.emails)[0].id
    }
    return ''
  }

  get templateList () {
    return this.$store.state.template.templates
  }

  get residentId () {
    return this.$route.params.residentId
  }

  get assignedTo () {
    return this.$route.params.assignedTo
  }

  get selectedStatement () {
    return this.$store.state.statement.selectedStatement
  }

  get residentContactList () {
    return (this.$store.state.resident.residentContacts || []).filter((contact: IResidentContact) =>
      (contact.firstName && contact.firstName !== '-' && contact.lastName && contact.lastName !== '-')
    )
  }

  get validated () {
    return (this.selected.emails && this.selected.emails.length) || (this.selected.addresses && this.selected.addresses.length)
  }

  async mounted () {
    this.isLoading = true
    await this.residentModuleInstance.fetchResidentContacts(this.residentId)
    if (this.type === 'template') {
      await this.templateModuleInstance.fetchTemplates({})
    } else {
      await this.statementModuleInstance.fetchStatementById(this.itemId)
    }
    this.selected.addresses = this.residentContactList
      .filter((contact: IResidentContact) => contact.isAddressUsedForMailing)
      .map((contact: IResidentContact) => contact.id)
    this.selected.emails = this.residentContactList
      .filter((contact: IResidentContact) => contact.isEmailUsedForMailing)
      .map((contact: IResidentContact) => contact.id)
    this.isLoading = false
  }

  updateSelected (selected: any) {
    this.selected = selected
  }

  goBack () {
    this.$locationManager.goBack({ name: 'management-collections' })
  }

  async send () {
    if (!this.validated) {
      return
    }

    this.isSending = true
    let res
    if (this.type === 'template') {
      res = await Api.resident.sendCollectionLetterMails(this.itemId, this.residentId, this.selected.addresses, this.selected.emails, this.assignedTo)
    } else if (this.type === 'statement') {
      res = await Api.resident.sendCollectionStatementMails(this.itemId, this.residentId, this.selected.addresses, this.selected.emails, this.assignedTo)
    }
    if (res === 'OK') {
      this.$eventBus.$emit('notify', {
          color: 'var(--status-success-color)',
          message: 'Mail successfully sent',
          header: `Send Mail`,
          icon: 'success'
      })
    }
    this.isSending = false
    this.goBack()
  }
}
